import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

export default function LoginComponent() {
  return (
    <div className="mx-auto container flex justify-center">
      <Card className="mt-16 p-3 min-w-[360px] rounded border-[1px]">
        <CardHeader>
          <CardTitle>Prex Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm">
            このサービスは新規の登録・ログインの受付を終了しました。
          </p>
          <p className="text-sm mt-2 text-muted-foreground">
            This service is closed. New sign-ups and logins are no longer
            accepted.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
